import { useEffect } from 'react';

export const useEventListener = <K extends keyof WindowEventMap, T extends WindowEventMap[K]>(
  type: K,
  listener: (event: T, signal: AbortSignal) => void,
  options: AddEventListenerOptions = {}
) =>
  useEffect(() => {
    const controller = new AbortController();
    const signal = options.signal ? AbortSignal.any([options.signal, controller.signal]) : controller.signal;
    self.addEventListener(type, (event: T) => listener(event, signal), { ...options, signal });
    return () => controller.abort();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
